import { render, staticRenderFns } from "./ReportSummaryAlt.vue?vue&type=template&id=e4f8200e&scoped=true"
import script from "./ReportSummaryAlt.vue?vue&type=script&lang=ts"
export * from "./ReportSummaryAlt.vue?vue&type=script&lang=ts"
import style0 from "./ReportSummaryAlt.vue?vue&type=style&index=0&id=e4f8200e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4f8200e",
  null
  
)

export default component.exports